import { Component } from '@angular/core';
import {
  ReactiveFormsModule,
  NonNullableFormBuilder,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { FormButtonComponent } from '../../../shared/components/form-controls/form-button/form-button.component';
import { TextInputComponent } from '../../../shared/components/form-controls/text-input/text-input.component';
import { DialogService } from '../../../core/services/dialog/dialog.service';
import { PasswordOtpComponent } from '../../../shared/components/dialogs/forget-password/password-otp/password-otp.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-forget-password',
    imports: [
        TranslateModule,
        TextInputComponent,
        ReactiveFormsModule,
        FormButtonComponent,
        RouterLink,
    ],
    templateUrl: './forget-password.component.html',
    styleUrl: './forget-password.component.scss'
})
export class ForgetPasswordComponent {
  constructor(
    private readonly fb: NonNullableFormBuilder,
    private readonly dialogService: DialogService
  ) {}

  private readonly destroy$ = new Subject<void>();
  forgetPasswordForm = this.fb.group({
    email: [
      '',
      [Validators.required, Validators.minLength(3), Validators.maxLength(320)],
    ],
  });
  currentYear = new Date().getFullYear();
  onSubmit(): void {
    this.dialogService.openDialog(
      PasswordOtpComponent,
      this.forgetPasswordForm.value
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
